import { useState } from 'react'

export const useSessionStorage = (key: string, initialValue: string | boolean) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.sessionStorage.getItem(key)

      return value ? JSON.parse(value) : initialValue
    } catch {
      return initialValue
    }
  })

  const setValue = (value: string) => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value))

      setStoredValue(value)
    } catch {}
  }

  return [storedValue, setValue]
}
